
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/timeout.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Timeout","toc":"menu","filename":"docs/x-sdk/demos/x-request/timeout.md","lastUpdated":1774233718000,"description":"为 XRequest 配置 timeout，设置请求超时时间。"};